import * as Constants from '../constants';

const initialState = {
  loading: false,
  specialitiesData: [],
  specialitiesTitle: '',
  selectedSpeciality: '',
  doctorLoading: false,
  doctorsData: [],
  doctorsTitle: '',
  selectedDoctor: null,
  slotLoading: false,
  slotData: [],
  slotsTitle: '',
  selectedDate: '',
  selectedSlot: null,
  bifurcationData: null,
  bifurcationLoading: false,
  patientDetails: { name: '', contact: '', age: '', gender: '' },
  consultMode: 'VIDEO',
  symptoms: '',
  appliedPromoCode: '',
  orderLoading: false,
  orderResult: null,
  error: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case Constants.FETCH_SPECIALITIES_START:
      return { ...state, loading: true, error: {} };
    case Constants.FETCH_SPECIALITIES_SUCCESS:
      return {
        ...state,
        loading: false,
        specialitiesData: action.data.data.concern || [],
        specialitiesTitle: (action.data.data.sectionInfo && action.data.data.sectionInfo.title) || '',
      };
    case Constants.FETCH_SPECIALITIES_FAILURE:
      return { ...state, loading: false, error: action.data };
    case Constants.SET_SELECTED_SPECIALITY:
      return { ...state, selectedSpeciality: action.data };
    case Constants.FETCH_DOCTORS_START:
      return { ...state, doctorLoading: true, error: {} };
    case Constants.FETCH_DOCTORS_SUCCESS:
      return {
        ...state,
        doctorLoading: false,
        doctorsData: action.data.data.doctors || [],
        doctorsTitle: (action.data.data.sectionInfo && action.data.data.sectionInfo.title) || '',
      };
    case Constants.FETCH_DOCTORS_FAILURE:
      return { ...state, doctorLoading: false, error: action.data };
    case Constants.SET_SELECTED_DOCTOR:
      return { ...state, selectedDoctor: action.data };
    case Constants.FETCH_SLOTS_START:
      return { ...state, slotLoading: true, error: {} };
    case Constants.FETCH_SLOTS_SUCCESS: {
      const slotData = action.data.data.slotData || [];
      const firstDate = slotData[0];
      const firstSlot = (firstDate && firstDate.slots && firstDate.slots[0]) || null;
      return {
        ...state,
        slotLoading: false,
        slotData,
        slotsTitle: (action.data.data.sectionInfo && action.data.data.sectionInfo.title) || '',
        selectedDate: (firstDate && firstDate.date) || '',
        selectedSlot: firstSlot,
      };
    }
    case Constants.FETCH_SLOTS_FAILURE:
      return { ...state, slotLoading: false, error: action.data };
    case Constants.SET_SELECTED_DATE:
      return { ...state, selectedDate: action.data, selectedSlot: null };
    case Constants.SET_DOC_CONSULT_SLOT:
      return { ...state, selectedSlot: action.data };
    case Constants.SET_PATIENT_DETAILS:
      return { ...state, patientDetails: { ...state.patientDetails, ...action.data } };
    case Constants.SET_CONSULT_MODE:
      return { ...state, consultMode: action.data };
    case Constants.SET_SYMPTOMS:
      return { ...state, symptoms: action.data };
    case Constants.SET_DOC_CONSULT_APPLIED_PROMO:
      return { ...state, appliedPromoCode: action.data };
    case Constants.FETCH_DOC_CONSULT_BIFURCATION_START:
      return { ...state, bifurcationLoading: true };
    case Constants.FETCH_DOC_CONSULT_BIFURCATION_SUCCESS:
      return { ...state, bifurcationLoading: false, bifurcationData: action.data };
    case Constants.FETCH_DOC_CONSULT_BIFURCATION_FAILURE:
      return {
        ...state,
        bifurcationLoading: false,
        bifurcationData: (action.data && action.data.amountBifurcation) ? action.data : state.bifurcationData,
      };
    case Constants.CREATE_DOC_CONSULT_ORDER_START:
      return { ...state, orderLoading: true, orderResult: null };
    case Constants.CREATE_DOC_CONSULT_ORDER_SUCCESS:
    case Constants.CREATE_DOC_CONSULT_ORDER_FAILURE:
      return { ...state, orderLoading: false, orderResult: action.data };
    default:
      return { ...state };
  }
}
